import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgOrderCancelled({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4a1 1 0 01.117 1.993l-.234.014a1 1 0 00-.876.876L6 7v12a1 1 0 00.883.993L7 20h10a1 1 0 00.993-.883l.014-.234A1 1 0 0120 19a3 3 0 01-2.824 2.995L17 22H7a3 3 0 01-2.995-2.824L4 19V7a3 3 0 013-3zm7.21 5.387l.083-.094a1 1 0 011.32-.083l.094.083L18 11.585l2.293-2.292a1 1 0 011.497 1.32l-.083.094L19.415 13l2.292 2.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083L18 14.415l-2.293 2.292a1 1 0 01-1.497-1.32l.083-.094L16.585 13l-2.292-2.293a1 1 0 01-.083-1.32l.083-.094-.083.094zM11 14a1 1 0 110 2H9a1 1 0 010-2h2zm0-4a1 1 0 010 2H9a1 1 0 110-2h2zm6-6a3 3 0 013 3 1 1 0 01-1.993.117l-.014-.234a1 1 0 00-.876-.876l-.234-.014A1 1 0 0117 4zm-3-1a1 1 0 010 2h-4a1 1 0 010-2h4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgOrderCancelled
